export default __webpack_public_path__ + "static/media/point-w.2c958bcb.svg";